module.exports = __webpack_public_path__ + "static/media/weathericons-regular-webfont.1cd48d78f06d33973d9d761d426e69bf.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/weathericons-regular-webfont.woff2
// module id = 267
// module chunks = 0